import React from 'react'
import classNames from 'classnames'
import classes from './styles.module.scss'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  className?: string
}

/**
 * Shimmering placeholder block. Dimension it either through the style props
 * or a consumer className — it renders nothing else, so the caller owns the
 * layout (and there is no risk of the skeleton-animation mixin's child-hiding
 * selector interacting with real content).
 */
export const Skeleton = ({ width, height, borderRadius, className }: SkeletonProps) => (
  <div
    className={classNames(classes.skeleton, className)}
    style={{ width, height, borderRadius }}
    data-testid='skeleton'
    aria-hidden='true'
  />
)
